/* eslint-disable max-len */
import { CoreTypography } from '@youscience/core';

import useSchoolSelectionStore from '@store/SchoolSelectionStore';

import TelescopeIcon from '@images/large-telescope.svg?react';

import { StyledNoteMessage } from './NoteMessage.styles';

export const NoteMessage = () => {
  const { school } = useSchoolSelectionStore((state) => state.schoolSelectionData);

  return (
    <StyledNoteMessage>
      <TelescopeIcon />

      <CoreTypography data-testid="selectionNoteMessage" variant="body2">
        {`${school?.label as string} is not currently a part of the YouScience network. As soon as ${
          school?.label as string
        } joins the YouScience
          network we will provide it with access to your personal YouScience profile, and will notify you that access has
          been granted.`}
      </CoreTypography>
    </StyledNoteMessage>
  );
};
